import { alpha } from "@mui/material";
import { CSSProperties } from "react";


export const GetLabelStyle = (theme: any): CSSProperties => ({
    position: "absolute",
    border: "1px solid",
    top: -10,
    left: 16,
    fontSize: 12,
    fontWeight: 500,
    padding: "0 4px",
    borderRadius: 6,
    pointerEvents: "none",
    transformOrigin: "left top",
    zIndex: 3,
    backgroundColor:
        theme.palette.mode === "dark"
            ? theme.palette.background.default
            : theme.palette.background.paper,
});

export const AsteriskStyle: CSSProperties = {
    color: "inherit",
    fontWeight: "bold",
    display: "inline-block",
    marginLeft: 2,
};

export const AdornmentStyle: CSSProperties = {
    position: "absolute",
    left: 12,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    pointerEvents: "none",
};

export const GetWrapperStyle = (sxWrapperStyles: any): CSSProperties => ({
    position: "relative",
    width: "100%",
    ...sxWrapperStyles,
});

export const GetSelectorStyle = (
    startAdornment: boolean,
    multiple: boolean,
    sxSelectorStyles: any
): CSSProperties => ({
    paddingLeft: startAdornment ? "43px" : "16px",
    border: "1px solid",
    borderRadius: 8,
    minHeight: multiple ? "auto" : "43px",
    height: "auto",
    padding: multiple ? "8px 12px" : "",
    background: "transparent",
    ...sxSelectorStyles,
});

export const GetCustomClearIconStyle = (color: string): CSSProperties => ({
    color,
    fontSize: 16,
    opacity: 0.7,
    cursor: "pointer",
});


export const DropdownVariants = {
    hidden: { opacity: 0, y: -4 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "tween",
            duration: 0.15,
            ease: [0.4, 0.0, 0.2, 1.0],
        },
    },
    exit: {
        opacity: 0,
        y: -4,
        transition: {
            duration: 0.1,
            ease: [0.4, 0.0, 1.0, 1.0],
        },
    },
};

export const GetAntdTheme = (materialColors: any, error: boolean) => {
    const natureBg = materialColors.isDark
        ? materialColors.surfaceContainer
        : materialColors.surfaceBright;

    return {
        token: {
            colorPrimary: materialColors.primary,
            colorError: materialColors.error,
            colorBgContainer: natureBg,
            colorBgElevated: materialColors.surfaceContainerHigh,
            borderRadius: 8,
            lineHeight: +materialColors.typography.body.medium.lineHeight,
            fontFamily: "'Google Sans', 'Roboto', sans-serif",
            fontSize: 16,
            fontWeightStrong: 500,

            // Backgrounds
            colorPrimaryBg: alpha(materialColors.primary, 0.05),
            colorPrimaryBgHover: alpha(materialColors.primary, 0.1),

            // Text
            colorTextPlaceholder: alpha(
                error ? materialColors.error : materialColors.onSurfaceVariant,
                error ? (materialColors.isDark ? 0.8 : 0.7) : 0.7
            ),
            colorText: materialColors.onSurface,
            colorTextDisabled: alpha(
                materialColors.onSurfaceVariant,
                materialColors.isDark ? 0.38 : 0.5
            ),

            // Borders
            colorBorder: alpha(
                error ? materialColors.error : materialColors.outline,
                error ? 0.8 : materialColors.isDark ? 0.5 : 1
            ),

            // Interactions
            colorPrimaryHover: materialColors.primary,
            colorBgContainerDisabled: alpha(
                materialColors.onSurfaceVariant,
                materialColors.isDark ? 0.05 : 0.08
            ),

            // Tags
            colorBgTextHover: alpha(
                materialColors.primary,
                materialColors.isDark ? 0.2 : 0.12
            ),
            colorBgTextActive: alpha(
                materialColors.primary,
                materialColors.isDark ? 0.25 : 0.15
            ),

            // Spacing
            paddingXS: 8,
            padding: 16,
            paddingLG: 24,
            margin: 8,
            marginXS: 4,
            marginLG: 16,

            // Controls
            controlHeight: 43,
            controlHeightLG: 56,
            controlHeightSM: 43,
            controlPaddingHorizontal: 16,

            // Z-index
            zIndexBase: 9999,
        },
        components: {
            Select: {
                controlHeight: 43,
                controlHeightLG: 56,
                controlHeightSM: 43,
                borderRadius: 8,
                padding: 16,
                borderRadiusLG: 8,
                borderRadiusSM: 8,
                activeBorderColor: alpha(materialColors.primary, 0.5),
                hoverBorderColor: alpha(materialColors.primary, 0.99),
                controlOutlineWidth: 2,

                optionSelectedBg: alpha(materialColors.primary, 0.12),
                optionSelectedColor: materialColors.primary,
                optionActiveBg: alpha(materialColors.primary, 0.08),
                optionPadding: "12px 16px",
                optionFontSize: 16,
                optionLineHeight: 1.5,

                clearBg: "transparent",
                selectorBg: "transparent",
                zIndexPopupBase: 9999,
            },
        },
    }
}
